import React from "react";
import {fontColorBlue,fontFaceMoontime,centeredText,fontColorDark,fontSizeFive} from './shared.module.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from "gatsby"


const ReComForYou = ({data})=>{
    return(
            <div className="container">
                <div className="columns">
                    <div className="column ">
                        <h1 className={fontFaceMoontime+' '+fontColorBlue+" "+centeredText+' '+fontSizeFive}>
                          Recommended For You
                        </h1>
                        <p className={`${centeredText} ${fontColorDark}`}>Looking for something else? Here are some of our other nearby communities that we think you'll love!</p>
                    </div>
                </div>
              <div className="columns">
                      {data && data.map((node)=>(
                  <div className="column is-one-quarter" key={node.id}>
                    <div className="card" style={{height:'100%'}}>
                            <div className="card-image" id="rcm4uimg">
                              <figure className="image " >
                                  {node.hero && <GatsbyImage image={getImage(node.hero.gatsbyImageData)} alt="Community Image" 
                                  style={{maxHeight:'212px',minHeight:'212px'}}/>}
                              </figure>
                            </div>
                            <div className="card-content">
                              <div className="content">
                                  <p className="is-size-4 do-not-translate" style={{marginBottom:'0'}}>
                                    <Link to={`/apartments/${node.area.toLowerCase()}/${node.citySlug.toLowerCase()}/${node.slug.toLowerCase()}/`}>{node.communityName}</Link>
                                    </p>
                                <p className={fontColorDark}>{node.description}</p>
                              </div>
                            </div>
                          </div>
                  </div>
                      ))}
              </div>

            </div>
    )
}



export default ReComForYou
